import {gql} from '@apollo/client'

// Catálogo de cursos (sin lecciones anidadas, con % de completitud del usuario)
export const ALL_COURSES = gql`
  query allCourses($isActive: Boolean, $name: String) {
    allCourses(isActive: $isActive, name: $name) {
      id
      name
      description
      coverImage {
        id
        name
        file
        url
        resourceType
      }
      category {
        id
        name
      }
      createdBy {
        id
        firstName
        lastName
      }
      isActive
      order
      lessonsCount
      completionPercentage
      createdAt
      updatedAt
    }
  }
`

// Detalle de curso con lecciones ordenadas y progreso del usuario por lección
export const COURSE_BY_ID = gql`
  query courseById($id: Int!) {
    courseById(id: $id) {
      id
      name
      description
      isActive
      order
      lessonsCount
      completionPercentage
      coverImage {
        id
        name
        file
        url
        resourceType
      }
      lessons {
        id
        title
        displayTitle
        order
        isRequired
        hasQuiz
        quiz {
          id
          title
          passingScorePercentage
          questionsCount
        }
        myProgress {
          id
          status
          completedAt
        }
        resource {
          id
          name
          description
          file
          url
          resourceType
        }
      }
    }
  }
`

// Quiz para tomarlo — NO incluye respuestas correctas (el backend no las expone)
export const QUIZ_BY_LESSON = gql`
  query quizByLesson($lessonId: Int!) {
    quizByLesson(lessonId: $lessonId) {
      id
      title
      passingScorePercentage
      questions {
        id
        text
        questionType
        order
        options {
          id
          text
          order
        }
      }
    }
  }
`

// Variante para el builder de quizzes (admin): incluye isCorrect
// (el backend devuelve null para usuarios sin rol de gestión)
export const QUIZ_BY_LESSON_ADMIN = gql`
  query quizByLessonAdmin($lessonId: Int!) {
    quizByLesson(lessonId: $lessonId) {
      id
      title
      passingScorePercentage
      questions {
        id
        text
        questionType
        order
        options {
          id
          text
          order
          isCorrect
        }
      }
    }
  }
`

export const MY_QUIZ_ATTEMPTS = gql`
  query myQuizAttempts($quizId: Int!) {
    myQuizAttempts(quizId: $quizId) {
      id
      scorePercentage
      passed
      submittedAt
    }
  }
`
